<template>
  <vs-sidebar
    click-not-close
    position-right
    parent="body"
    default-index="1"
    color="primary"
    class="add-new-data-sidebar items-no-padding"
    spacer
    v-model="isSidebarActiveLocal"
  >
    <div class="mt-6 flex items-center justify-between px-6">
      <h4 class="font-bold">{{ $t("editOrder") }}</h4>
      <feather-icon
        icon="XIcon"
        @click.stop="isSidebarActiveLocal = false"
        class="cursor-pointer"
      ></feather-icon>
    </div>
    <vs-divider class="mb-0"></vs-divider>

    <component
      :is="scrollbarTag"
      class="scroll-area--data-list-add-new"
      :settings="settings"
      :key="$vs.rtl"
    >
      <div
        class="p-6"
        style="position: relative; height: 100%"
        v-if="this.loadingData"
      >
        <spinner-color />
      </div>

      <div class="p-6" v-else>
        <!-- receiver -->
        <div style="position: relative">
          <label class="input-label font-bold">
            {{ $t("receiver") }} :
            <span style="font-size: 1.2rem" class="text-danger font-bold"
              >*</span
            >
            </label
          >
          <vs-input
            maxlength="100"
            minlength="3"
            v-model="editData.receiver"
            class="w-full"
            name="receiver"
            v-validate="'required'"
          />
          <span style="font-size: 0.7rem" class="text-danger font-bold">{{
            errors.first("receiver")
          }}</span>
        </div>

        <!-- sender -->
        <div style="position: relative" class="mt-5">
          <label class="input-label font-bold"> {{ $t("sender") }} : </label>
          <SelectInputVue
            maxlength="100"
            v-model="editData.second_client"
            class="w-full"
            name="secondClient"
            :options="sub_clients"
          />
        </div>

        <!-- mobeil1 -->
        <div style="position: relative" class="mt-5">
          <label class="input-label font-bold">
            {{ $t("number1") }} :
            <span style="font-size: 1.2rem" class="text-danger font-bold"
              >*</span
            ></label
          >
          <vue-tel-input
          :defaultCountry="returnDefaultCountry(editData.phone2) || 'LY' "
            mode="international"
            v-model="editData.phone1"
            :inputOptions="internationalInputOptions"
            :validCharactersOnly="true"
            @validate="phoneObject($event, 'phone1')"
            name="number"
            v-validate="'required'"
          ></vue-tel-input>
          <span style="font-size: 0.7rem" class="text-danger font-bold"
            >{{ errors.first("number")
            }}<span v-if="!this.validationsPhone.phone1 && editData.phone1"
              >يجب ادخال رقم هاتف صحيح</span
            ></span
          >
        </div>

        <!-- mobeil2 -->
        <div style="position: relative" class="mt-5">
          <label class="input-label font-bold"> {{ $t("number2") }} : </label>
          <vue-tel-input
            v-model="editData.phone2"
            :inputOptions="internationalInputOptions"
            :validCharactersOnly="true"
            :defaultCountry="returnDefaultCountry(editData.phone2) || 'LY' "
            mode="international"
            @validate="phoneObject($event, 'phone2')"
            name="number2"
          ></vue-tel-input>
          <span style="font-size: 0.7rem" class="text-danger font-bold"
            >{{ errors.first("number2")
            }}<span v-if="!this.validationsPhone.phone2"
              >يجب ادخال رقم هاتف صحيح</span
            ></span
          >
        </div>

        <!-- mobileFollow -->
        <div style="position: relative" class="mt-5">
          <label class="input-label font-bold">
            {{ $t("numbreTracking") }} :
          </label>
          <vue-tel-input
            v-model="editData.api_followup_phone"
            :inputOptions="internationalInputOptions"
            :validCharactersOnly="true"
            :defaultCountry="returnDefaultCountry(editData.api_followup_phone) || 'LY'"
            mode="international"
            @validate="phoneObject($event, 'api_followup_phone')"
            name="follow_up_phone"
          ></vue-tel-input>
          <span style="font-size: 0.7rem" class="text-danger font-bold"
            >{{ errors.first("mobileFollow")
            }}<span v-if="!this.validationsPhone.api_followup_phone"
              >يجب ادخال رقم هاتف صحيح</span
            ></span
          >
        </div>

        <!-- gov -->
        <div v-if="canEditProductOrGovernment">
          <div class="input-select mt-5">
            <label class="label-select font-bold" ref="govLabel"
              >المدينة :
              <span style="font-size: 1.2rem" class="text-danger font-bold"
                >*</span
              ></label
            >
            <SelectInputVue
              :default="editData.government_id"
              :edit="true"
              :options="resultGovs"
              v-model="editData.government_id"
              v-validate="'required'"
              @input="changeRegions(editData.government_id, editData.type == 1 ? 'false' : 'true')"
            >
              <template #search>
                <input
                  @blur.stop
                  class="inner-input"
                  v-model="editData.search"
                  @input="searchAll()"
                  placeholder="إبحث هنا"
                />
              </template>
            </SelectInputVue>
            <span v-if="resultCost && editData.government_id && !areaResultCost" style="font-size: 0.7rem" class="font-bold">
              تكلفة الشحن {{ resultCost}}
            </span>
          </div>
        </div>

<!-- Area -->
        <div style="position: relative" class="mt-5">
          <label class="input-label font-bold">
            {{ $t("area") }} :
            <span v-if="editData.government_id==5 || editData.government_id==11 ||editData.government_id==283 || editData.government_id==232 || editData.government_id==4" style="font-size: 1.2rem" class="text-danger font-bold"
                >*</span
              >
            </label
          >
          <div v-if="!loadingRegions">
            <SelectInputVue
            v-if="editData.government_id==5 || editData.government_id==11 ||editData.government_id==283 || editData.government_id==232 || editData.government_id==4" 
              v-validate="'required'"
              :default="editData.area_id"
              :edit="true"
              :options="resultRegions"
              v-model="editData.area_id"
              ref="regions"
              name="area"
              @input="changeAreas(editData.area_id, editData.type == 1 ? 'false' : 'true')"
            >
              <template #search>
                <input
                  @blur.stop
                  class="inner-input"
                  v-model="searchAreaWord"
                  @input="searchArea()"
                  placeholder="إبحث هنا"
                />
              </template>
            </SelectInputVue>

            <SelectInputVue
              v-else
              :default="editData.area_id"
              :edit="true"
              :options="resultRegions"
              v-model="editData.area_id"
              ref="regions"
              name="area"
              @input="changeAreas(editData.area_id, editData.type == 1 ? 'false' : 'true')"
            >
              <template #search>
                <input
                  @blur.stop
                  class="inner-input"
                  v-model="searchAreaWord"
                  @input="searchArea()"
                  placeholder="إبحث هنا"
                />
              </template>
            </SelectInputVue>
            <span style="font-size: 0.7rem" class="text-danger font-bold">{{
              errors.first("area")
            }}</span>
             <span v-if="areaResultCost && editData.area_id" style="font-size: 0.7rem" class="font-bold">
              تكلفة الشحن {{ areaResultCost}}
            </span>
          </div>
          <SkeletonLoadingVue v-else />
        </div>

        <!-- address -->
        <div style="position: relative" class="mt-5">
          <label class="input-label font-bold">
            {{ $t("address") }} :
            
            </label
          >
          <vs-input
            maxlength="100"
            minlength="3"
            v-model="editData.address"
            class="w-full"
            name="address"
            v-validate="'min:3'"
          />
          <span style="font-size: 0.7rem" class="text-danger font-bold">{{
            errors.first("address")
          }}</span>
        </div>

        <!-- amount -->
        <div style="position: relative" class="mt-5">
          <label class="input-label font-bold">
            {{ $t("itemPrice") }} :
            <span style="font-size: 1.2rem" class="text-danger font-bold"
              >*</span
            ></label
          >
          <vs-input
            :disabled="!hasAccess || editData.client_status == allStatus.withCaptain"
            ref="collectedAmount"
            maxlength="20"
            v-model="editData.amount_to_be_collected"
            class="w-full"
            type="number"
            name="collectedAmount"
            v-validate="
              parseInt(this.total_balance) < 0
                ? 'required|min_value:0'
                : 'required'
            "
          />
          <span style="font-size: 0.7rem" class="text-danger font-bold">{{
            errors.first("collectedAmount")
          }}</span>
        </div>

        <!-- reason change_amount_to_be_collected -->
        <div
          style="position: relative"
          class="mt-5"
          v-if="do_change_amount_to_be_collected"
        >
          <label class="input-label font-bold">
            سبب تعديل المبلغ المطلوب تحصيله :
            <span style="font-size: 1.2rem" class="text-danger font-bold"
              >*</span
            ></label
          >
          <vs-input
            ref="reasonCollectedAmount"
            maxlength="20"
            v-model="editData.amount_to_be_collected_reason"
            class="w-full"
            type="text"
            name="reasonCollectedAmount"
            v-validate="'required|min:3'"
          />
          <span style="font-size: 0.7rem" class="text-danger font-bold">{{
            errors.first("reasonCollectedAmount")
          }}</span>
        </div>
        <!-- returnValue -->
        <!-- 
        <div style="position: relative" class="mt-5">
          <label class="input-label font-bold">
            {{ $t("returnValue") }} :
            <span style="font-size: 1.2rem" class="text-danger font-bold"
              >*</span
            >
          </label>
          <vs-input
            :disabled="!hasAccess"
            ref="return_amount"
            maxlength="20"
            v-model="editData.return_amount"
            class="w-full"
            type="number"
            name="returnValue"
          />
          <span style="font-size: 0.7rem" class="text-danger font-bold">{{
            errors.first("returnValue")
          }}</span>
        </div>
        -->
        <!-- contentOrder -->
        <div style="position: relative" class="mt-5">
          <label class="input-label font-bold">
            {{ $t("contentOrder") }} :
            </label
          >   <span style="font-size: 1.2rem" class="text-danger font-bold"
              >*</span
            >
          <vs-input
          v-validate="'required|min:3'"
            maxlength="100"
            minlength="3"
            v-model="editData.order_summary"
            class="w-full"
            name="contentOrder"
          />
          <span style="font-size: 0.7rem" class="text-danger font-bold">{{
            errors.first("contentOrder")
          }}</span>
        </div>

        <div style="position: relative" class="mt-5">
          <!-- Total Amount -->
          <label class="input-label font-bold">
            {{ $t("totalAmount") }}
          </label>
          <vs-input
              v-model="totalAmount"
              maxlength="20"
              type="number"
              class="w-full"
              name="totalAmount"
              disabled
              :placeholder="$t('totalAmount')"
          />
        </div>

        <div style="position: relative" class="mt-5">
          <!-- piecesCount -->
          <label class="input-label font-bold">
            {{ $t("piecesCount") }}
          </label>
          <vs-input
              v-validate="'numeric'"
              v-model="editData.pieces_count"
              maxlength="20"
              type="number"
              class="w-full"
              name="piecesCount"
              :placeholder="$t('piecesCount')"
          />
          <span style="font-size: 0.7rem" class="text-danger font-bold">
            {{ errors.first("pieces_count") }}
          </span>
        </div>

        <!-- notes -->
        <div style="position: relative" class="mt-5">
          <label class="input-label font-bold"> {{ $t("notes") }} : </label>
          <vs-input
            maxlength="250"
            minlength="3"
            v-model="editData.notes"
            class="w-full"
            name="notes"
          />
        </div>

        <!-- invoice -->
        <div style="position: relative" class="mt-5">
          <label class="input-label font-bold">
            {{ $t("invoiceNumber") }} :
          </label>
          <vs-input
            ref="invoice_number"
            v-model="editData.invoice_number"
            class="w-full"
            name="invoiceNumber"
          />
        </div>

        <!-- Do given order -->
        <div style="display: flex; align-items: center; flex-wrap: wrap">
          <label class="input-label font-bold mt-5 mb-3 w-full">
            {{ $t("willOrderBe") }}</label
          >
          <span
            style="display: flex; align-items: center"
            class="mr-2"
            :key="item.id"
            v-for="item in payload"
          >
            <input
              style="cursor: pointer"
              :value="item.id"
              v-model="editData.is_order"
              :id="item.id"
              class="custom-control-primary mr-1"
              type="radio"
            />
            <label style="cursor: pointer; font-size: 12px" :for="item.id">{{
              item.name
            }}</label>
          </span>
        </div>

        <!-- Accept 50 Dinar -->
        <!-- <div
          class="w-full flex-wrap"
          style="display: flex; align-items: center; grid-column: span 12"
        >
          <label class="input-label font-bold mt-5 mb-3 w-full">
            {{ $t("Aceept20Plus5Dinar") }}</label
          >
          <span
            style="display: flex; align-items: center"
            class="mt-2 mr-2"
          >
            <span class="checked" v-if="editData.accept_20_plus_5_dinar == 1">
            </span>
            <span
              class="unchecked"
              v-if="editData.accept_20_plus_5_dinar != 1"
              @click="editData.accept_20_plus_5_dinar = 1"
            >
            </span>
            <input
              style="cursor: pointer"
              :value="1"
              v-model="editData.accept_20_plus_5_dinar"
              id="accept_20_plus_5_dinar"
              class="custom-control-primary mr-1"
              type="radio"
              name="radiosGroup"
            />
            <label
              style="cursor: pointer; font-size: 0.875rem; margin-left: 1.5rem"
              :style="[
                editData.accept_20_plus_5_dinar == 1
                  ? { color: '#31006F' }
                  : { color: '#6E6B7B' },
              ]" for="accept_20_plus_5_dinar"
              >{{ $t("Yes") }}</label
            >
          </span>

          <span
            style="display: flex; align-items: center"
            class="mt-2 mr-2"
          >
            </span>
            <span
              class="unchecked"
              v-if="editData.accept_20_plus_5_dinar == 1"
              @click="editData.accept_20_plus_5_dinar = 0"
            >
            </span>
            <input
              style="cursor: pointer"
              :value="0"
              v-model="editData.accept_20_plus_5_dinar"
              id="accept_20_plus_5_dinar1"
              class="custom-control-primary mr-1"
              type="radio"
              name="radiosGroup"
            />
            <label
              style="cursor: pointer; font-size: 0.875rem; margin-left: 1.5rem"
              :style="[
                editData.accept_20_plus_5_dinar != 1 
                  ? { color: '#31006F' }
                  : { color: '#6E6B7B' },
              ]" for="accept_20_plus_5_dinar1"
              >{{ $t("No") }}</label
            >
        </div> -->
        <!-- Return Summry -->
        <div
          style="position: relative"
          class="mt-5"
          v-if="![0, 4].includes(editData.is_order)"
        >
          <label class="input-label font-bold">
            {{ $t("contentReturn") }} :
            <span style="font-size: 1.2rem" class="text-danger font-bold"
              >*</span
            ></label
          >
          <vs-input
            maxlength="100"
            minlength="3"
            v-model="editData.return_summary"
            class="w-full"
            name="returnSummry"
            v-validate="'required|min:3'"
          />
        </div>
        <vs-checkbox
          v-if="editData.is_order != 4"
          name="checkbox"
          v-model="editData.can_open"
          class="remember m-0 mt-5"
          > {{ $t("canOpen") }}</vs-checkbox
        >
        <vs-checkbox
          v-if="editData.is_order != 4"
          name="checkbox"
          :disabled="editData.can_open == 0"
          v-model="editData.is_measurable"
          class="remember m-0 mt-5"
          >  {{ $t("isMeasurable") }}</vs-checkbox
        >
        <vs-checkbox
          v-if="editData.is_order != 4"
          name="checkbox"
          v-model="editData.is_fragile"
          class="remember m-0 mt-5"
          >  {{ $t("isFragile") }}
        </vs-checkbox>
          <!-- Alert for "fragile" -->
          <div v-if="editData.is_order != 4 && editData.is_fragile"
            class="alert alert-success mt-4"
            style="background: #e0f7e9; padding: 10px; border-radius: 5px; color: #2e7d32;"
          >
            {{ $t("fragileSelectedMessage") }}
          </div>
          <!-- Alert for "not fragile" -->
          <div v-else-if="editData.is_order != 4"
            class="alert alert-warning mt-4"
            style="background: #fff3cd; padding: 10px; border-radius: 5px; color: #856404;"
          >
            {{ $t("fragileNotSelectedMessage") }}
          </div>
        <!-- <vs-checkbox
          name="checkbox"
          v-model="editData.has_packaging_bag"
          class="remember m-0 mt-5"
          >تغليف الطلب ؟</vs-checkbox
        > -->
        <editProductsSection
          :edit="true"
          :canEditProduct="canEditProductOrGovernment"
          ref="products"
          v-if="have_stock === 1"
        />
      </div>
    </component>

    <div class="flex flex-wrap items-center p-6" slot="footer">
      <button
        class="mr-6 send-order"
        v-if="!loading"
        :class="{ 'opacity-btn1': !isFormValid }"
        @click="
          googleEventTrack(
            'الضغط على زر حفظ التعديل',
            'edit_order_component',
            'edit_order_action'
          ),
            submitData()
        "
        :disabled="!isFormValid"
      >
        {{ $t("save") }}
      </button>
      <button class="mr-6 flex items-center justify-center send-order" v-else>
        <spinner-color />
      </button>
      <button class="cancel-btn" @click="isSidebarActiveLocal = false">
        {{ $t("cancel") }}
      </button>
    </div>
  </vs-sidebar>
</template>

<script>
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import { mapActions, mapGetters, mapState } from "vuex";
import SpinnerColor from "./SpinnerColor2.vue";
import globalMixin from "@/mixins/mixins.js";
import helper from "@/mixins/helper.js";
import orderStatusMixin from "@/mixins/orderStatus.js";
import notifyState from "@/mixins/notifyState";
import editProductsSection from "../../products/SelectProductsSection.vue";
import SpinnerColor2Vue from "./SpinnerColor2.vue";
import landLine from "@/mixins/landLine";
import removeSpaceNumber from "@/mixins/removeSpaceNumber.js";
import gTag from "@/mixins/gtag.js";
import SelectInputVue from "@/layouts/components/SelectInput.vue";
import regionsMixins from "@/mixins/regions.js";
import SkeletonLoadingVue from "@/layouts/components/SkeletonLoading.vue";
import validationPhone from "@/mixins/validationPhone.js";
import searchReagions from "@/mixins/searchRegions.js";
import aclAccess from "@/mixins/hasAccess";
import allStatus from '@/views/status/orderStatus'
import Axios from "axios";

export default {
  name: "edit-data",
  mixins: [
    globalMixin,
    helper,
    orderStatusMixin,
    notifyState,
    landLine,
    removeSpaceNumber,
    gTag,
    regionsMixins,
    validationPhone,
    searchReagions,
    aclAccess
  ],
  props: {
    isSidebarActive: {
      type: Boolean,
      required: true,
    },
    orderId: {
      required: true,
    },
    pageName: {
      type: String,
    },
  },
  components: {
    VuePerfectScrollbar,
    SpinnerColor,
    SpinnerColor2Vue,
    editProductsSection,
    SelectInputVue,
    SkeletonLoadingVue,
  },
  data() {
    return {
      sub_clients:[],
      editData: {
        receiver: "",
        phone1: "",
        phone2: "",
        api_followup_phone: "",
        area: "",
        area_id: "",
        address: "",
        amount_to_be_collected: "",
        return_amount: "",
        order_summary: "",
        government_id: "",
        is_order: 0,
        return_summary: "",
        second_client: "",
        notes: "",
        search: "",
        government_name: "",
        invoice_number: "",
        amount_to_be_collected_reason: "",
        is_measurable: 0,
        is_fragile: 0,
        can_open: 0,
        status: "",
        accept_20_plus_5_dinar: 1,
        // has_packaging_bag: 0,
        pieces_count : 0
      },
      resultGovs: [],
      settings: {
        // perfectscrollbar settings
        maxScrollbarLength: 60,
        wheelSpeed: 0.6,
      },
      loading: false,
      do_change_amount_to_be_collected: false,
      loadingData: false,
      allStatus: allStatus,
    };
  },
  watch: {
    "editData.amount_to_be_collected": {
      handler: function (newVal, oldVal) {
        if (newVal != this.order_details.amount_to_be_collected) {
          this.do_change_amount_to_be_collected = true;
        } else {
          this.do_change_amount_to_be_collected = false;
        }
      },
      deep: true,
    },
    "editData.is_order": {
        handler(val) {
          if (val == 4) {
            this.editData.return_summary = "عربون";
            this.editData.is_fragile = 0;
            this.editData.can_open = 0;
            this.editData.is_measurable = 0;

          } else {
            this.editData.return_summary = "";
          }
      },
      deep: true,
    },
    "editData.phone1"(newVal) {},
    "editData.can_open": {
      handler(val) {
        if (val == 0) {
          this.editData.is_measurable  = 0;
        }
      },
    },
  },
  computed: {
    ...mapGetters("dataList", [
      "active_governments",
      "payload",
      "order_details",
      "success_api",
      "max_order_updated_at",
    ]),
    ...mapGetters("userData", ["have_stock", "total_balance"]),
    ...mapState("externalApi", ["regions"]),
    isFormValid() {
      if (!this.errors.any()) {
        if (
       (this.do_change_amount_to_be_collected &&
          !this.editData.amount_to_be_collected_reason)||(this.editData.government_id==4 && !this.editData.area_id)||(this.editData.government_id==5 && !this.editData.area_id)||(this.editData.government_id==11 && !this.editData.area_id)||(this.editData.government_id==283 && !this.editData.area_id)||(this.editData.government_id==232 && !this.editData.area_id)
          )
         {
          return false;
        }
        if (
          this.editData.is_order == 0 || 
          this.editData.is_order == 4 ||
          (this.editData.is_order != 0 &&
            this.editData.return_summary != null &&
            this.editData.return_summary != "")
        ) {
          return true;
        } else {
          return false;
        }

      }
    },
    isSidebarActiveLocal: {
      get() {
        return this.isSidebarActive;
      },
      set(val) {
        if (!val) {
          this.$emit("closeSidebar");
        }
      },
    },
    scrollbarTag() {
      return this.$store.getters.scrollbarTag;
    },
    canEditProductOrGovernment() {
      if (
        this.order_details.client_status == this.statusOfOrder.saved ||
        this.order_details.client_status == this.statusOfOrder.sent
      ) {
        return true;
      } else {
        return false;
      }
    },
    totalAmount() {
      let total = this.editData.amount_to_be_collected;
      let cost = this.areaResultCost && this.editData.area_id ? this.areaResultCost : this.resultCost;
      let shipping_cost = this.editData.shipping_payer == 1 ? +cost : 0;
      return +total + +shipping_cost;
    }
  },
  methods: {
    ...mapActions("dataList", [
      "postOrder",
      "editOrder",
      "fetchDataListItems",
      "editOrderSubmit",
      "orderDetails",
    ]),
    ...mapActions("externalApi", ["fetchRegions", "getCost","getAreaCost"]),
    searchAll() {
      if (this.editData.search != "") {
        this.resultGovs = this.active_governments.filter((govs) =>
          govs.name.toLowerCase().includes(this.editData.search.toLowerCase())
        );
      } else {
        this.resultGovs = this.active_governments;
      }
    },
    async submitData() {
      this.$validator.validateAll().then(async (result) => {
        this.loading = true;
        if (this.editData.is_order == 0) {
          this.editData.return_summary = "";
        }
        if (this.editData.is_order == 4) {
          //default value in deposit order type
          this.editData.is_fragile = 0;
          this.editData.can_open = 0;
          this.editData.is_measurable = 0;
          this.editData.return_summary = "عربون";
        }else{
          //chenge true and false to 1 and 0
          this.editData.can_open = this.editData.can_open ? 1 : 0,
          this.editData.is_measurable = this.editData.is_measurable ? 1 : 0,
          this.editData.is_fragile = this.editData.is_fragile ? 1 : 0
        }
        // if (this.editData.has_packaging_bag)
        //   this.editData.has_packaging_bag = 1;
        if (result && this.validPhone) {
          if (this.have_stock === 1) {
            let products = [
              ...this.$refs.products.slectedProducts,
              ...this.$refs.products.searchProducts,
            ];
            products = products.filter((product) => product.selected == true);
            if (products.length) {
              this.editData.order_products = products;
            } else this.editData.order_products = "[]";
          }
          this.editData.area = this.$refs.regions.selected.name;
          if(!this.editData.second_client || typeof this.editData.second_client  != 'number') delete this.editData.second_client
   
          await this.editOrderSubmit(this.editData);
          if (this.$store.state.dataList.successApi == 1) {
            this.notifySuccess("editToast");
            window.location.reload();
          } else {
            this.notifyFaild("faildEdit",this.$store.state.dataList.err_msg);
          }
          if (this.pageName != "order/details") {
            let credentials = {
              page: this.pageName,
              pageNum: "",
              itemsPerPage: "",
              maxOrderUpdatedAt: this.max_order_updated_at,
            };
            this.fetchDataListItems(credentials);
          }
          this.$emit("closeSidebar");
        }
        this.loading = false;
      });
    },
  },
  async created() {
    this.loadingData = true;
    this.loadingRegions = true;
    await this.editOrder(this.orderId);
    this.resultGovs = this.active_governments;
    const response = await Axios.get('second-clients/index')
    this.sub_clients = response.data.data
    
        
    this.editData = {
      ...this.order_details,
    };
    
    
    if (!this.canEditProductOrGovernment)
    {

      this.changeRegions(this.editData.government_id);
      this.changeAreas(this.editData.area_id);
    }
    this.loadingData = false;
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/vuexy/_editOrder.scss";
@import "@/assets/scss/vuexy/_product.scss";
</style>

<style lang="scss">
.add-new-data-sidebar {
  .vue-tel-input {
    .vti__input {
      direction: rtl;
    }
  }
}
.product {
  .vs-checkbox-primary .vs-checkbox {
    border: 2px solid #fff !important;
    width: 20px;
    height: 20px;
    margin-right: 11px;
    border-radius: 4px;
  }
  .con-slot-label {
    color: #fff;
    font-size: 14px;
    font-weight: 600;
    line-height: 27px;
  }
}
</style>
